import React from 'react';
import { Clock3 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

const FoodSafetyNotice = () => {
  const { t } = useLanguage();
  const { isDark } = useTheme();

  return (
    <div className="max-w-7xl mx-auto px-4 pt-3 sm:pt-4 pb-2">
      <div
        role="note"
        className={`flex items-start sm:items-center gap-3 rounded-xl border px-4 py-3.5 text-[13px] sm:text-sm leading-relaxed font-medium ${
          isDark
            ? 'bg-[#C8102E]/10 border-[#C8102E]/35 text-white/85'
            : 'bg-red-50 border-red-200 text-red-900'
        }`}
      >
        <Clock3 className="mt-0.5 sm:mt-0 flex-shrink-0 text-[#C8102E]" size={20} aria-hidden="true" />
        <span>{t('food_safety_notice')}</span>
      </div>
    </div>
  );
};

export default FoodSafetyNotice;
